import { render, staticRenderFns } from "./ChallengesCommerciaux.vue?vue&type=template&id=20f9e828&"
import script from "./ChallengesCommerciaux.vue?vue&type=script&lang=js&"
export * from "./ChallengesCommerciaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports